import { Typography } from 'br2s-ui-componentlibrary_r2_02';
import MaintenanceImg from '../../../public/assets/maintenance/maintenance-img.svg';
import './ComingSoon.scss';

function ComingSoon() {
  return (
    <div id="coming-soon" className="error-page-container container">
      <div className="error-page-content">
        <img
          src={MaintenanceImg}
          alt={MaintenanceImg}
          className="error-page-image-coming-soon"
        />
        <div className="title-description-wrapper">
          <Typography
            label={
              process.env.REACT_APP_TEMPORARY_UNAVAILABLE_HEADER as string
            }
            type="headline-6"
            weight="regular"
          />
          <div className="description-wrapper">
            <div>
              {
                process.env
                  .REACT_APP_TEMPORARY_UNAVAILABLE_DESCRIPTION as string
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
